module.exports = __webpack_public_path__ + "img/planta_14.6e64edae.png";